import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  class: "d-flex justify-content-center",
  style: {"width":"100%"}
}
const _hoisted_2 = ["src"]

import PersonalTable from "@/components/PersonalTable.vue";
    import Api from "@/services/api";
    import { Category, Product } from "@/services/types";
    import { ElMessage, ElMessageBox, FormInstance, FormRules } from "element-plus";
    import { onBeforeMount, reactive, ref } from "vue";
    import { useRoute, useRouter } from "vue-router";
    // import { useStore } from "vuex";

    
export default /*@__PURE__*/_defineComponent({
  __name: 'CategoryView',
  setup(__props) {

    const route = useRoute()
    const router = useRouter()
    const {id} = route.params
    const loading = ref<boolean>(true)
    const updating = ref<boolean>(false)
    const formRef = ref<FormInstance>()
    
    const category = reactive<Category>({
        name: ''
    })

    const rules = reactive<FormRules<Product>>({
        name: [{required: true, message: 'Insira o nome da categoria'}],
    })

    const image = ref()
    const uri = ref<string>()
    const imageFile = ref<File | Blob>()

    const selectImage = () => {
        imageFile.value = image.value?.input.files[0]
        uri.value = URL.createObjectURL(imageFile.value as File)
    }

    const getCategory = async () => {
        updating.value = true
        const res = await Api.get('admin/categories/' + id)
        if (res.status == 200) {
            const data = res.data.category
            category.name = data.name
            category.image = data.image
            uri.value = `${Api.publicUrl}/images/categories/${category.image?.url}`
            category.id = data.id
            category.products = data.products
        } else if (res.status != 404) {
            ElMessageBox.alert('Ocorreu um erro ' + res.data.message, {type: "error"}).then(() => router.push('/products')).catch(() => router.push('/products'))
        }
        updating.value = false
    }

    onBeforeMount(async () => {
        loading.value = true

        await getCategory()

        loading.value = false
    })

    const update = async (formEl: FormInstance | undefined) => {
        if (!formEl) { return }
        await formEl.validate(async (valid) => {
            if (valid) {
                updating.value = true
                const form = new FormData()
                if (category.name) {
                    form.append("name", category.name)
                }
                if (imageFile.value) {
                    form.append("image", imageFile.value)
                }

                const res = await Api.post('admin/categories/' + id, category, form)
                console.log(res.data)

                if (res.status == 200) {
                    ElMessage.success({message: 'Actualizado com sucesso'})
                    // location.reload()
                } else if (res.status == 422) {
                    if (res.data.errors) {
                        for(let err in res.data.errors) {
                            ElMessage.error({message: res.data.errors[err].join(', ')})
                        }
                    }
                } else {
                    ElMessage.error({message: 'Ocorreu um erro ' + res.data.message})
                }
                updating.value = false
            }
        })
    }

    const see = (product: Product) => {
        router.push('/products/' + product.id)
    }

return (_ctx: any,_cache: any) => {
  const _component_el_result = _resolveComponent("el-result")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_View = _resolveComponent("View")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createBlock(_component_el_row, {
    gutter: 30,
    justify: "center"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_card, {
        header: category.name,
        class: "col-12 col-md-10 col-lg-8"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_skeleton, {
            loading: loading.value,
            animated: "",
            rows: 12
          }, {
            default: _withCtx(() => [
              (!category.id)
                ? (_openBlock(), _createBlock(_component_el_row, {
                    key: 0,
                    justify: "center",
                    align: "middle"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, {
                        sm: 12,
                        lg: 7
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_result, {
                            icon: "error",
                            title: "Categoria não encontrada",
                            "sub-title": "A categoria que procura não foi encontrada, por favor verifique se consta da lista"
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createVNode(_component_el_form, {
                      rules: rules,
                      ref_key: "formRef",
                      ref: formRef,
                      model: category,
                      disabled: updating.value,
                      "label-position": "top"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_row, {
                          gutter: 20,
                          justify: "start"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_col, { sm: 24 }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_1, [
                                  (uri.value)
                                    ? (_openBlock(), _createElementBlock("img", {
                                        key: 0,
                                        src: uri.value,
                                        style: {"max-width":"170px"}
                                      }, null, 8, _hoisted_2))
                                    : _createCommentVNode("", true)
                                ]),
                                _createVNode(_component_el_form_item, {
                                  prop: "image",
                                  label: "Selecione uma imagem"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_input, {
                                      type: "file",
                                      ref_key: "image",
                                      ref: image,
                                      name: "image",
                                      onChange: selectImage
                                    }, null, 512)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_col, {
                              sm: 24,
                              md: 14,
                              lg: 16
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_form_item, {
                                  label: "Nome da categoria",
                                  prop: "name"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_input, {
                                      modelValue: category.name,
                                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((category.name) = $event)),
                                      name: "name"
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_col, {
                              sm: 24,
                              md: 10,
                              lg: 8
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_form_item, { label: "Salvar" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_button, {
                                      plain: "",
                                      type: "primary",
                                      size: "large",
                                      loading: updating.value,
                                      onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (update(formRef.value)), ["prevent"]))
                                    }, {
                                      default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                                        _createTextVNode(" Salvar alterações ", -1)
                                      ]))]),
                                      _: 1
                                    }, 8, ["loading"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["rules", "model", "disabled"]),
                    _createVNode(_component_el_collapse, {
                      accordion: "",
                      "model-value": ['1']
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_collapse_item, {
                          name: "1",
                          title: "Produtos nesta categoria"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(PersonalTable, {
                              loading: loading.value,
                              height: 350,
                              showRows: 7,
                              cols: [
                                        {label: 'Cod', prop: 'id'},
                                        {label: 'Nome', prop: 'name'},
                                        {label: 'Preço', prop: 'price'},
                                    ],
                              data: category.products
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_table_column, {
                                  align: "center",
                                  label: "Ver mais"
                                }, {
                                  default: _withCtx((data) => [
                                    _createVNode(_component_el_button, {
                                      type: "primary",
                                      onClick: ($event: any) => (see(data.row))
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_icon, null, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_View)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }, 8, ["onClick"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["loading", "data"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ], 64))
            ]),
            _: 1
          }, 8, ["loading"])
        ]),
        _: 1
      }, 8, ["header"])
    ]),
    _: 1
  }))
}
}

})